/**
 * Protected Route Component
 * Redirects to login if user is not authenticated.
 * Tool deep links (/tools/:toolKey) are kept and restored after login.
 */
import { Navigate, useLocation } from "react-router-dom";
import { useClerkReady } from "../../hooks/app/useClerkReady";
import {
  rememberAuthReturnPath,
  safeAuthReturnPath,
} from "../../utils/authReturnPath";

function ProtectedRoute({ children }) {
  const location = useLocation();
  const { isLoaded, isSignedIn, clerkReady } = useClerkReady();

  if (!clerkReady) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (isLoaded && !isSignedIn) {
    const returnPath = safeAuthReturnPath(location.pathname);
    if (returnPath) rememberAuthReturnPath(returnPath);
    const params = new URLSearchParams(location.search);
    if (returnPath) params.set("redirect", returnPath);
    const qs = params.toString();
    return <Navigate to={qs ? `/login?${qs}` : "/login"} replace />;
  }

  return children;
}

export default ProtectedRoute;





